<template>
  <c-m-sidebar title="Merge History">
    <template #content>
      <div class="merged__patients">
        <template v-if="patients">
          <template v-if="patients.length">
            <div class="merged__patient" :key="index" v-for="(patient, index) in patients">
              <div class="merged__patient-head">
                <span>
                  <router-link :to="{ name: 'patients.edit', params: { id: patient.id }}">
                    {{ $helpers.mask('patient_name', patient.display_name) }} ({{ patient.active ? 'Active' : 'Inactive' }})
                  </router-link>
                </span>
                <span class="merged__merge-time">MERGED @ {{ $helpers.formatDate(patient.updated_at) }}</span>
              </div>
            </div>
          </template>
          <div class="merged__no-merge-patients" v-else>No merged patients found</div>
        </template>
      </div>
    </template>
  </c-m-sidebar>
</template>

<script>
import CMSidebar from "@/components/safety_center/CMSidebar.vue";
import to from "@/lib/to";

export default {
  name: "PatientMergeHistorySidebar",
  components: {CMSidebar},
  props: ['patientId'],
  async mounted() {
    const [err, response] = await to(this.$http.get(`/patients/${this.patientId}/merged_patients`))
    if (!err) {
      this.patients = response.data
    }
  },
  data() {
    return {
      patients: null
    }
  }
}
</script>

<style scoped lang="scss">
.merged__patient {
  background: #fff;
  padding: 15px 10px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.merged__patient-head {
  font-size: 14px;
  display: flex;
  flex-direction: column;
}
.merged__merge-time {
  font-size: 9px;
  font-weight: 500;
  opacity: 0.6;
  letter-spacing: 0.6px;
  margin-top: 3px;
}
.merged__no-merge-patients {
  text-align: center;
  margin-top: 10px;
}
</style>
